module.exports = __webpack_public_path__ + "static/media/payoo.cf8aa0ed.png";